export default "__VITE_ASSET__644caad9__"